import { BoxProps } from '@jfs/ui-new'

const style = {
  superParent: {
    flex: 1,
    bg: 'WHITE',
  } as BoxProps,
}
export { style }
